<template>
  <div class="admin">
    <Servicios></Servicios>
  </div>
</template>

<script>
import Servicios from '@/components/Servicios'

export default {
  name: 'admin',
  components: {
    Servicios,
  },
}
</script>

<style scoped>
  .admin{
    width: 100%;
    height: 100%;
  }
</style>


